import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { IEpGridModel, IEpGridSelectionOptions } from '@epicor/kinetic';
import { EpbtFaQuickTransferService } from '../../services/epbt-fa-quick-transfer.service';
import { EpbtFaQuickTransferLineModel } from '../../models/epbt-fa-quick-transfer-line-model';


declare var $: any;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-quick-transfer-summary-products-grid',
  templateUrl: './epbt-fa-quick-transfer-summary-products-grid.component.html',
  styleUrls: ['./epbt-fa-quick-transfer-summary-products-grid.component.scss']
})
export class EpbtFaQuickTransferSummaryProductsGridComponent implements OnInit {

  public gridModel: IEpGridModel;

  @ViewChild('summaryQuantityTemplate', { static: true }) summaryQuantityTemplate: TemplateRef<any>;

  constructor(private quciktransferService: EpbtFaQuickTransferService) { }

  ngOnInit() {
    // this.gridModel = this.getGridModel();
    // this.updateSummaryGridData();
  }



  getGridModel(): IEpGridModel {
    const selectionOptions: IEpGridSelectionOptions = {
      selectByField: 'productId',
      selectedKeys: [],
    };
    const model: IEpGridModel = {
      resizable: false,
      reorderable: false,
      groupable: false,
      filterable: false,
      scrollable: 'scrollable',
      rowHeight: 20,
      height: this.getHeight(),
      sortable: true,
      selectionOptions: selectionOptions,
      columns: [
        { field: 'productId', title: '', width: 30, hidden: true },
        { field: 'description', title: 'DESCRIPTION', width: 30, hidden: false },
        { field: 'productCode', title: 'CODE', width: 30, hidden: false },
        { field: 'quantity', title: 'QUANTITY', width: 30, hidden: false, cellTemplate: this.summaryQuantityTemplate },
        { field: 'quantityTally', title: 'TALLY', width: 30, hidden: false },
      ],
    };
    $(window).resize(() => {
      this.updateGrid();
    });
    return model;
  }



  updateSummaryGridData() {
    this.gridModel = this.getGridModel();
    if (this.quciktransferService.quickTransfer.quickTransferLines.length > 0) {
      // this.gridModel.data = this.quciktransferService.quickTransfer.quickTransferLines.slice();
      this.quciktransferService.quickTransfer.quickTransferLines.slice();
      const lines: any[] = [];
      this.quciktransferService.quickTransfer.quickTransferLines.forEach(element => {
        const line: any = {
          productId: element.product.productId,
          description: element.product.description,
          productCode: element.product.productCode,
          quantity: element.quantity,
          quantityTally: element.quantityTally,
          perCode: element.inputPer.perCode
        };
        lines.push(line);
      });
      this.gridModel.data = lines;
    } else {
      this.gridModel.data = null;
    }

    // this.gridModel.data = this.data;
  }

  // getHeight(): number {
  //   var height = parseInt($('body').height());

  //   if (height > 900) {
  //     //return 300;
  //     return 600;
  //   }
  //   else return 550;//return 500;
  // }
  updateGrid() {
    const calHeight = this.getHeight();
    this.gridModel.height = calHeight;
  }

  getHeight(): number {
    const height = $(window).outerHeight() - 425; // 593
    const width = parseInt($('body').width());

    if (width > 250 && width < 1023) {
      // mobile and ipad
      return 400;
    }
    return height;

  }


}
